<template>
  <div class="mci-noti">
    <!-- <button @click="playNewNotiSound">TEST SOUND</button> -->
    <el-popover
      v-model="notiPopVisible"
      trigger="click"
      popper-class="noti-pop"
      placement="bottom"
      @hide="hidePopover"
    >
      <div class="noti-container">
        <div class="noti-header">
          <h4 class="noti-header__label">Thông báo</h4>
        </div>

        <div class="noti-content">
          <div v-if="notiList.length !== 0" class="noti-list">
            <div
              v-for="noti in notiList"
              :key="noti.id"
              class="noti-item"
              :class="{ 'noti-item--not-seen': !noti.seen }"
            >
              <div class="noti-item__main-content">{{ noti.description }}</div>
              <div class="noti-item__time">{{ noti.create_date }}</div>
            </div>

            <!-- SKELETON -->
            <template v-if="isFetchingNoti">
              <div
                v-for="item in [1, 2]"
                :key="item"
                class="noti-item__skeleton"
              >
                <el-skeleton animated>
                  <template slot="template">
                    <el-skeleton-item variant="p" />
                    <el-skeleton-item variant="p" />
                    <el-skeleton-item variant="text" style="width: 120px" />
                  </template>
                </el-skeleton>
              </div>
            </template>

            <!-- NO NOTIFICATION -->
          </div>
          <div v-else class="noti-empty">
            <div class="noti-empty__text">Bạn chưa có thông báo mới!</div>
          </div>
        </div>
        <div class="see-more-noti flex justify-center" style="padding: 10px 0">
          <a role="button" @click="showAllNotifications">
            Xem tất cả thông báo
          </a>
        </div>
      </div>

      <i slot="reference" class="mci-icon-notification" />
    </el-popover>
    <div v-if="notiList.length > 0" class="noti-badge">
      {{ notiList.length }}
    </div>
    <!-- dialog -->
    <portal to="tax">
      <el-dialog
        title="Thông báo"
        :visible.sync="dialogNotiVisible"
        :close-on-click-modal="false"
        width="900px"
        destroy-on-close
        @close="closeDialogNoti"
      >
        <search-comp
          :search-show="true"
          @onSearch="onSearch"
          @onReset="onReset"
        >
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row align-end">
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Tên người tạo</div>
                    <input v-model="searchParams.userInfo" type="text" />
                  </div>
                </div>
                <div class="das-form-col col-4">
                  <div class="das-form-input">
                    <div class="label">Ngày thông báo</div>
                    <CalendarSelect v-model="searchParams.date" mode="date" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div style="height: 500px">
          <GridVx
            ref="agGrid"
            :columns="columns"
            :auto-size-cell="true"
            :auto-select-first-row="false"
            class="agGrid"
            dom-layout="scroll"
            :rows="rows"
            row-selection="single"
            @doubleClicked="onSelectNotify"
          />
        </div>
        <div class="grid-bottom">
          <GridPaging
            target="agGrid"
            :total-size="totalPage"
            :page-num="currentPage"
            :page-size="searchParams.pageSize"
            @pageChanged="onPageChanged"
            @onPageSizeChange="onPageSizeChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="button-containers">
            <button
              class="btn primary small"
              @click="dialogNotiVisible = false"
            >
              Đóng
            </button>
          </div>
        </div>
      </el-dialog>
    </portal>
    <audio id="myAudio">
      <source src="@/assets/sounds/notisound.mp3" />
    </audio>
  </div>
</template>

<script>
import Vue from 'vue'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)
// eslint-disable-next-line no-unused-vars
import { getUserGroupNotificationListApi } from '@/api/config-service/user-group-notification'
import Stomp from 'stompjs'
// eslint-disable-next-line no-unused-vars
import { getUserDetailApi } from '@/api/profile/profile'
// eslint-disable-next-line no-unused-vars
import { getNotiList, putSeenNotiList } from '@/api/configuration/notify'

// eslint-disable-next-line no-unused-vars
// const getMockNotiList = () => {
//   const tmpList = []

//   for (let i = 0; i < 10; i++) {
//     tmpList.push({
//       id: Math.round(Math.random() * 10000) / 1000,
//       description:
//         'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do iusmod tempor incididunt ut labore et dolore magna aliqua',
//       create_name: 'Dasvision Dev',
//       create_date: '2024-01-14 17:34:30',
//       seen: Math.random() > 0.5
//     })
//   }

//   return tmpList
// }

export default {
  data() {
    return {
      searchParams: {
        seen: true,
        pageNum: 1,
        pageSize: 10,
        userInfo: null,
        date: null
      },
      totalPage: 0,
      currentPage: 0,
      columns: [
        {
          headerName: 'Nguời tạo',
          field: 'create_name',
          tooltipField: 'create_name',
          maxWidth: 200
        },
        {
          headerName: 'Thời gian tạo',
          valueGetter: param => {
            return (
              this.$moment(param?.data?.create_date).format(
                'DD-MM-YYYY HH:mm'
              ) || null
            )
          },
          tooltipValueGetter: param => {
            return (
              this.$moment(param?.data?.create_date).format(
                'DD-MM-YYYY HH:mm'
              ) || null
            )
          },
          maxWidth: 200
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description'
        }
      ],
      rows: [],
      dialogNotiVisible: false,
      currentUserId: null,
      connection: null,
      notiPopVisible: false,
      enableFetchNoti: true, // Flag for debounce,
      notiQueryParams: {
        pageSize: 10,
        pageNum: 1
      },
      notiList: [],
      isFetchingNoti: true
    }
  },
  watch: {
    notiPopVisible: {
      async handler(val) {
        if (val) {
          const ids = this.notiList.map(item => item.id)
          const data = {
            ids: ids
          }
          await putSeenNotiList(data)
        } else {
          // RESET POP-UP
          this.notiList = []
          this.notiQueryParams = {
            pageSize: 10,
            pageNum: 1
          }
          // this.enableFetchNoti = true
          // this.isFetchingNoti = null
        }
      }
    }
  },
  async mounted() {
    const userIf = await getUserDetailApi()
    this.currentUserId = userIf.data?.user?.id

    const notiContentEle = document.querySelector('.noti-content')
    notiContentEle.addEventListener('scroll', async () => {
      const { offsetHeight, scrollTop, scrollHeight } = notiContentEle

      if (this.enableFetchNoti && offsetHeight + scrollTop === scrollHeight) {
        this.enableFetchNoti = false
        await this.getNotificationList()
        this.enableFetchNoti = true
      }
    })
    this.connectSocket()
    this.getNotificationList()
  },
  beforeDestroy() {
    this.currentUserId = null
  },
  methods: {
    onSearch() {
      this.getAllNotifications(this.searchParams)
    },
    onReset() {
      this.searchParams = {
        seen: true,
        pageNum: 1,
        pageSize: 10,
        userInfo: null,
        date: null
      }
      this.getAllNotifications(this.searchParams)
    },
    playNewNotiSound() {
      // var audio = new Audio('@/assets/sounds/notisound.mp3')
      // audio.play()
      const x = document.getElementById('myAudio')
      x.play()
    },
    closeDialogNoti() {
      this.searchParams = {
        seen: true,
        pageNum: 1,
        pageSize: 10,
        userInfo: null,
        date: null
      }
    },
    async getAllNotifications(params) {
      const data = await getNotiList(params)
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      // eslint-disable-next-line eqeqeq
      this.currentPage = data.data.length == 0 ? 0 : data.pageNum
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.getAllNotifications(this.searchParams)
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.getAllNotifications(this.searchParams)
    },
    async showAllNotifications() {
      await this.getAllNotifications(this.searchParams)
      this.dialogNotiVisible = true
      this.notiPopVisible = false
    },
    hidePopover() {
      setTimeout(() => {
        this.getNotificationList()
      }, 500)
    },
    async connectSocket() {
      const CHANNEL = '/topic/public'
      this.connection = new WebSocket(process.env.VUE_APP_SOCKET_HOST)
      const stompClient = Stomp.over(this.connection)
      stompClient.connect({}, () => {
        // Subscribe to a Stomp topic
        stompClient.subscribe(CHANNEL, async message => {
          const content = JSON.parse(message.body).content
          if (content.indexOf(String(this.currentUserId)) === -1) {
            return
          } else {
            this.getNotificationList()
            // .then(res => {
            //   this.playNewNotiSound()
            // })
            // .catch(error => {
            //   console.log(error)
            // })
          }
          // Handle incoming messages
        })
      })
    },
    timeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async getNotificationList() {
      // getUserGroupNotificationListApi(this.notiQueryParams).then(res => {
      //   this.notiList = [...this.notiList, ...res.data]
      // })
      this.isFetchingNoti = true
      const params = {
        seen: false
      }
      const data = await getNotiList(params)
      this.notiList = data.data
      if (this.notiList.length) {
        this.playNewNotiSound()
      }
      // console.log('Get Notification list')
      // await this.timeout(2000)
      // this.notiList = [...this.notiList, ...getMockNotiList()]
      this.isFetchingNoti = false
    },
    onSelectNotify(rows) {
      // console.log(rows)
      const routeData = this.$router.resolve({
        path: '/configuration/diary/system',
        query: {
          create_user_id: rows[0].create_user_id,
          date: rows[0].create_date.split(' ')[0]
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss">
.noti-pop {
  --noti-not-seen-bg: rgba(235, 238, 245, 0.4);
  --noti-hover-bg: rgba(235, 238, 245, 0.9);
  --noti-empty-color: #37352fa6;
  // 167, 167,167,0
  // top: 40px !important;
  // right: 140px !important;
  // left: 400px;
  padding: 0;
  // padding-bottom: 20px;
  color: #000;
  .noti-container {
    .noti-header {
      border-bottom: 1px solid #dedfe7;
      // box-shadow: 0 4px 4px -3px rgb(0 0 0 / 0.1);
      padding: 20px 20px 15px;

      h4 {
        margin: 0;
        font-size: 16px;
        line-height: 20px;
      }

      .noti-header__actions {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        margin-top: 10px;
        gap: 10px;

        .noti-header__action-item {
          cursor: pointer;
          padding: 4px;
          border: 1px solid rgba(55, 53, 47, 0.16);
          border-radius: 5px;
          font-size: 13px;
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          transition: background 50ms ease-in 0s;

          &:hover {
            background: rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .noti-content {
      min-height: 200px;
      // height: 200px;
      max-height: 320px;
      overflow-y: auto;
      // margin: 0 6px 0 12px;
      border-bottom: 1px solid #dedfe7;
      .noti-list {
        .noti-item {
          &.noti-item--not-seen {
            background-color: var(--noti-not-seen-bg);

            &::before {
              content: '';
              display: block;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #357456;
              position: absolute;
              left: 16px;
              top: 15px;
            }
          }

          &:hover {
            background-color: var(--noti-hover-bg);
          }

          .noti-item__main-content {
            margin-bottom: 5px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .noti-item__time {
            font-size: 12px;
            color: #65676b;
          }
        }

        .noti-item,
        .noti-item__skeleton {
          padding: 10px 32px 10px 32px;
          border-bottom: 1px solid #dedfe7;
          position: relative;
        }
      }

      .noti-empty {
        // display: none;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 200px;
      }

      &.noti-content--empty {
        height: 160px;
        .noti-empty {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          justify-content: center;
          color: var(--noti-empty-color);

          .noti-empty__img {
            padding-bottom: 20px;
          }
        }
      }

      &::-webkit-scrollbar {
        width: 6px;
      }
    }
  }
}

// sytv
.mci-noti {
  position: relative;
  .noti-badge {
    background: red;
    /* height: 20px; */
    position: absolute;
    /* width: 47px; */
    font-size: 9px;
    font-weight: 700;
    top: -6px;
    color: white;
    min-width: 20px;
    left: 13px;
    padding: 4px;
    border-radius: 9999px;
    text-align: center;
    user-select: none;
  }
}
.see-more-noti {
  a {
    &:hover {
      color: #357456;
    }
  }
}
</style>
